﻿'use strict';

angular.module('ntmApp').controller('DataCollectionController', ['$uibModalInstance', '$scope', 'data',
    function ($uibModalInstance, $scope, data) {
        $scope.DataCollection = data.DataCollection;

        $scope.cancel = function () {

            if ($scope.DataCollection.editMode) {
                $scope.DataCollection.confirmExit($uibModalInstance);
                
            } else {
                $uibModalInstance.close($scope.DataCollection.dataHasChanged);
            }
        };

        function initialize() {
            $scope.DataCollection.init(data);
        }
        initialize();

        $scope.$on('modal.closing', function (event, reason) {

            if ($scope.DataCollection.editMode) {
                switch (reason) {
                    // clicked outside
                    case "backdrop click":
                        event.preventDefault();
                        $scope.DataCollection.confirmExit($uibModalInstance);
                        break;
                        // escape key
                    case "escape key press":
                        event.preventDefault();
                        $scope.DataCollection.confirmExit($uibModalInstance);
                        break;
                }
            }

            if ($scope.DataCollection.dataHasChanged) {
                switch (reason) {
                    // clicked outside
                    case "backdrop click":
                        event.preventDefault();
                        $uibModalInstance.close($scope.DataCollection.dataHasChanged);
                        break;
                        // escape key
                    case "escape key press":
                        event.preventDefault();
                        $uibModalInstance.close($scope.DataCollection.dataHasChanged);
                        break;
                }
            }
        });

    }]);
